import SIIConnectionForm from '@/components/settings/SIIConnectionForm';

export default function ConexionSIIPage() {
  return <SIIConnectionForm />;
}
